export enum AcompanhamentoAtaActionTypes {
  /** Enfileira o cálculo e passa a acompanhá-lo. */
  ACTION_INICIAR = 'ACTION_INICIAR_ACOMPANHAMENTO_ATA',

  /** Acompanha um trabalho que já existe — retomada após F5 ou troca de tela. */
  ACTION_ACOMPANHAR = 'ACTION_ACOMPANHAR_ACOMPANHAMENTO_ATA',

  /** Retoma o que estava guardado no navegador. Chamado na montagem da caixa. */
  ACTION_RESTAURAR = 'ACTION_RESTAURAR_ACOMPANHAMENTO_ATA',

  /**
   * Passa a acompanhar um trabalho encontrado no servidor — tipicamente disparado por outra pessoa
   * da secretaria. Sem filtros de relatório: a emissão continua sendo de quem pediu.
   */
  ACTION_ADOTAR = 'ACTION_ADOTAR_ACOMPANHAMENTO_ATA',

  /** Reabre a caixa sem mexer no cálculo. */
  ACTION_MOSTRAR = 'ACTION_MOSTRAR_ACOMPANHAMENTO_ATA',

  /** Recolhe/expande a caixa. */
  ACTION_ALTERNAR_RECOLHIDA = 'ACTION_ALTERNAR_RECOLHIDA_ACOMPANHAMENTO_ATA',

  /** Fecha e esquece — só o usuário faz isso. */
  ACTION_ENCERRAR = 'ACTION_ENCERRAR_ACOMPANHAMENTO_ATA',
}
